"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GENERAL = void 0;
var GENERAL = {
  INPUT__SEARCH: 'products-input-search',
  BUTTON__CATEGORY_FILTER: 'products-div-categoryFilter',
  BUTTON__WAREHOUSE_FILTER: 'products-div-warehouseFilter',
  BUTTON__IMPORT_EXPORT_CSV: 'products-button-importExportCSV',
  BUTTON__UPLOAD_CSV: 'products-button-uploadCSV',
  BUTTON__EXPORT_CSV: 'products-button-exportCSV',
  BUTTON__ADD_ONE_PRODUCT: 'products-button-addOneProduct',
  BUTTON__MANAGE_PRODUCTS: 'products-button-manageProducts',
  BUTTON__CREATE_PRODUCT: 'products-button-createNewProduct',
  BUTTON__ADD_INVENTORY: 'products-button-addInventory',
  BUTTON__TRANSFER_INVENTORY: 'products-button-transferInventory',
  BUTTON__REMOVE_INVENTORY: 'products-button-removeInventory'
};
exports.GENERAL = GENERAL;